import React from 'react'
import {
    BrowserRouter as RouterApp,
    Switch,
    Route
} from "react-router-dom";

import Home from "../Components/Home"
import Login from "../Components/Login new"
import HomeLI from "../Components/HomeLI"
import NewGuide from "../Components/NewGuide new"
import NewMember from "../Components/NewMember new"
import NewAccount from "../Components/NewAccount new"
import AccountRules from "../Components/AccountRules new"
import Accounts from "../Components/Accounts new"
import Guidelines from "../Components/Guidelines new"
import YourTeam from "../Components/YourTeam new"
import NewAdmin from "../Components/NewAdmin new"
import AccountUpdate from "../Components/AccountUpdate new"
import UserUpdate from "../Components/UserUpdate new"
import CampaignRules from "../Components/CampaignRules new"
import Policy from "../Components/Policy"
import HowToUse from "../Components/HowToUse"
export default function Router() {
    return (
        <div>
            <RouterApp>
                <Switch>
                    <Route path="/" exact component={Home} />
                    <Route path="/home" component={Home} />
                    <Route path="/login" component={Login} />
                    <Route path="/homeli" component={HomeLI} />
                    <Route path="/newguideline" component={NewGuide} />
                    <Route path="/newmember" component={NewMember} />
                    <Route path="/newaccount" component={NewAccount} />
                    <Route path="/accounts" component={Accounts} />
                    <Route path="/guidelines" component={Guidelines} />
                    <Route path="/yourteam" component={YourTeam} />
                    <Route path="/newadmin" component={NewAdmin} />
                    <Route path="/accountrules/:platform/:accountname" component={AccountRules} />
                    <Route path="/accountupdate/:id" component={AccountUpdate} />
                    <Route path="/userupdate/:id" component={UserUpdate} />
                    <Route path="/campaignrules/:name" component={CampaignRules} />
                    <Route path="/privacy-policy" component={Policy} />
                    <Route path="/howto" component={HowToUse} />
                </Switch>
            </RouterApp>


        </div>
    )
}
